// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 60 60"
    {...props}
  >
    <path
      stroke="#6421B9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M32.5 7.5H35C37.7625 7.5 40 9.7375 40 12.5 40 9.7375 42.2375 7.5 45 7.5H47.5M40 47.5V12.5M32.5 32.5 27.5 27.5M32.5 27.5 27.5 32.5M21.4453 32.5 16.4453 27.5M21.4453 27.5 16.4453 32.5M47.5 52.5H45C42.2375 52.5 40 50.2625 40 47.5 40 50.2625 37.7625 52.5 35 52.5H32.5M32.5 42.5H12.5C9.7375 42.5 7.5 40.2625 7.5 37.5V22.5C7.5 19.7375 9.7375 17.5 12.5 17.5H32.5M40 42.5H47.5C50.2625 42.5 52.5 40.2625 52.5 37.5V22.5C52.5 19.7375 50.2625 17.5 47.5 17.5H40"
    />
  </svg>
);
const IconPasswordForgot = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconPasswordForgot;
